export function formatEinInput(input: string): string {
  let value = input.replace(/[^0-9]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  if (value.length > 2) {
    value = `${value.slice(0, 2)}-${value.slice(2)}`;
  }
  return value;
}
